import PropTypes from 'prop-types';
import React from 'react';
import SimpleCheckbox from '../../../../common/simpleCheckbox';
import Input from '../../../../common/input';

const PromoUsableEveryNumberOfDays = ({ isUsableEveryNumberOfDays }) => (
  <div className="layout">
    <div className="layout__item u-2/5">
      <SimpleCheckbox
        label="Recurring Promo"
        id="isUsableEveryNumberOfDays"
        name="isUsableEveryNumberOfDays"
      />
    </div>
    <div className="layout__item u-3/5" display-if={isUsableEveryNumberOfDays}>
      <div className="o-flexbox o-flexbox--content-align-center">
        <span className="u-fontsize-small">
          Promo can be used once every
        </span>
        <Input type="number" name="usableEveryNumberOfDays" className="c-input u-width-60" />
        <span className="u-fontsize-small">
          day(s).
        </span>
      </div>
    </div>
  </div>
);

PromoUsableEveryNumberOfDays.propTypes = {
  isUsableEveryNumberOfDays: PropTypes.bool.isRequired,
};

export default PromoUsableEveryNumberOfDays;
